import { Button } from '@newfront-insurance/core-ui/v2';
import { Loader2, Plus } from 'lucide-react';
import type { ReactNode } from 'react';

import { getErrorMessage, type CustomSkillManagementTab } from './custom-skill-model';
import { CustomSkillTabs } from './custom-skill-tabs';

export function CustomSkillsPage({
  activeTab,
  mySkillCount,
  sharedSkillCount,
  showMySkills,
  showSharedSkills,
  isLoading,
  error,
  children,
  onAddSkill,
  onRetry,
  onTabChange,
}: {
  activeTab: CustomSkillManagementTab;
  mySkillCount: number;
  sharedSkillCount: number;
  showMySkills: boolean;
  showSharedSkills: boolean;
  isLoading: boolean;
  error?: unknown;
  children: ReactNode;
  onAddSkill: () => void;
  onRetry: () => void;
  onTabChange: (tab: CustomSkillManagementTab) => void;
}) {
  return (
    <div className="flex min-h-0 w-full flex-1 flex-col gap-6 bg-white">
      <div className="flex w-full items-center gap-4">
        <div className="min-w-0 flex-1">
          <h2 className="font-['Open_Sans',sans-serif] text-[17px] leading-6 font-normal text-[#262D46]">Skills</h2>
          <p className="mt-1 font-['Open_Sans',sans-serif] text-[12px] leading-4 text-[#546A83]">
            Reusable prompts you trigger with / in any chat.
          </p>
        </div>
        {showMySkills ? (
          <button
            type="button"
            onClick={onAddSkill}
            className="inline-flex h-10 shrink-0 items-center justify-center gap-2 rounded-full px-4 font-['Open_Sans',sans-serif] text-[14px] leading-5 font-semibold text-[#350E5E]"
            style={{ backgroundImage: 'linear-gradient(150deg, #97ECE3 2%, #DBC1F4 82%)' }}
          >
            <Plus className="h-[18px] w-[18px]" />
            New skill
          </button>
        ) : null}
      </div>

      <CustomSkillTabs
        activeTab={activeTab}
        mySkillCount={mySkillCount}
        sharedSkillCount={sharedSkillCount}
        showMySkills={showMySkills}
        showSharedSkills={showSharedSkills}
        showWtwSkills
        onChange={onTabChange}
      />

      <div className="min-h-0 flex-1 overflow-y-auto [scrollbar-gutter:stable]">
        {isLoading ? (
          <div className="flex items-center justify-center py-10">
            <Loader2 className="h-5 w-5 animate-spin text-[#546A83]" />
            <span className="ml-2 text-sm text-[#546A83]">Loading custom skills...</span>
          </div>
        ) : error ? (
          <div className="rounded-[4px] border border-[#DEE2E7] bg-white p-4">
            <p className="text-sm text-[#C5342A]">{getErrorMessage(error, 'Unable to load custom skills.')}</p>
            <Button type="button" className="mt-3" onClick={onRetry}>
              Retry
            </Button>
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
}
